import {memo} from 'react'

const Blur = memo(() => {
  return (
    
    <div className='h-full w-full bg-gradient-to-r from-white/[0%] to-white/[100%]' >

    </div>
  )
})

export default Blur
